import React from "react";
import { IconUser } from "../../icons/Icon";
import "../../assets/styles/smu-user-icon.scss";

const SmuUserIcon = ({ color, styles }) => {
  return (
    <div
      className="smu-user-icon"
      style={{ backgroundColor: color, ...styles }}
    >
      <IconUser color="#fff" />
    </div>
  );
};

export default SmuUserIcon;
